import { useRef } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Button } from '@iwoca/orion';

import redQuarterSVG from './redQuarterCircle.svg';
import { useGetANTFormalOffers } from '../../hooks/useGetANTFormalOffers';

export const CrossSellCard = () => {
  const { antFormalOffers, loadingANTFormalOffers } = useGetANTFormalOffers();
  const hasTrackedView = useRef(false);

  const trackView = () => {
    if (hasTrackedView.current) return;
    hasTrackedView.current = true;
    tracking.ampli.buyerDisplayedXSellBanner();
  };

  if (loadingANTFormalOffers) return null;
  if (antFormalOffers && antFormalOffers.length > 0) return null;

  trackView();

  const handleClick = () => {
    tracking.ampli.buyerClickedXSellBanner();
    window.location.href = '/apply-flexi-loan/?ipxsell=1';
  };

  return (
    <div className="relative z-0 mb-xl overflow-hidden rounded-l bg-primary-20 p-l">
      <img
        src={redQuarterSVG}
        alt=""
        className="pointer-events-none absolute right-0 top-0 z-0 select-none"
      />
      <div className="flex w-full items-center justify-between gap-s text-structure-100 sm:flex-col sm:gap-l">
        <div>
          <h2 className="m-0 mb-xs text-xl font-bold">
            Get a business loan with iwoca
          </h2>
          <p className="m-0 text-s font-reg">
            Borrow &pound;1,000 &ndash; &pound;1,000,000 to buy new stock,
            invest in growth plans or just keep your cash flow smooth.
          </p>
        </div>
        <div className="flex flex-col items-center gap-s sm:w-full">
          <Button
            variant="secondary"
            onClick={handleClick}
            id="applyForFlexi_INCLUDE"
            className="z-10 w-full"
          >
            Apply now
          </Button>
          <p className="m-0 p-0 text-center text-xs font-med text-structure-100">
            Applying won't affect your credit score
          </p>
        </div>
      </div>
    </div>
  );
};
